<template>
  <select v-model="selected" @change="$store.dispatch('selectPlaylist', selected)">
    <option value="0" >פלייליסט</option>
    <option v-for="pl in playlists" :key="pl.id" :value="pl.id">
      {{pl.title}}
    </option>
  </select>
</template>

<script>
export default {
  data(){
    return {
      selected: 0
    }
  },
  computed: {
    playlists(){
      return this.$store.state.user.playlists;
    },
  },
  methods:{
    
  },
  mounted(){
    this.selected = this.$store.state.user.playlistSelected
  }
}
</script>

<style>

</style>